module.exports = __webpack_public_path__ + "a92e771eb38ec20acaf041d006d9a1b1.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/_common/Slider/images/image2.png
// module id = k1iT
// module chunks = 0